export function shouldCleanupForIdentityChange({
  currentFamilyId, nextFamilyId, currentUid, nextUid,
  callState, callFamilyId, expectedCallFamilyId,
}) {
  const familyChanged = Boolean(currentFamilyId && nextFamilyId && currentFamilyId !== nextFamilyId);
  const userChanged = Boolean(currentUid && nextUid && currentUid !== nextUid);
  if ((!familyChanged && !userChanged) || callState === "idle") return false;
  const expectedCallTransition = familyChanged
    && !userChanged
    && expectedCallFamilyId === nextFamilyId
    && callFamilyId === nextFamilyId
    && ["gelen", "baglaniyor"].includes(callState);
  return !expectedCallTransition;
}

